import OregonCityPageTemplate from "@/pages/oregon-city/CityPageTemplate";
import { astoriaConfig } from "./data";

export default function AstoriaPage() {
  return <OregonCityPageTemplate config={astoriaConfig} />;
}